import React from 'react';
import SharedDragGrip from './SharedDragGrip';
import {
  createLinkDragPayload,
  setSharedAttachmentDragData,
} from '../../utils/sharedFilesDrag';
import { useAttachmentTouchInteraction } from '../../utils/sharedFilesTouchDrag';
import { usePrefersCoarsePointer } from '../../utils/usePrefersCoarsePointer';

const DraggableLinkThumb = ({
  link,
  href,
  canDrag,
  children,
  onTouchAttachmentDrop,
  onTouchHighlight,
  onSharedDragStart,
  onSharedDragEnd,
  className = '',
}) => {
  const coarsePointer = usePrefersCoarsePointer();
  const payload = createLinkDragPayload(link.messageId);
  const canDragLink = Boolean(canDrag);

  const touchHandlers = useAttachmentTouchInteraction({
    enabled: coarsePointer && canDragLink,
    payload,
    onTap: undefined,
    onDrop: onTouchAttachmentDrop,
    onHighlight: onTouchHighlight,
  });

  const handleDragStart = (e) => {
    if (!canDragLink) {
      e.preventDefault();
      return;
    }
    setSharedAttachmentDragData(e, payload);
    window.requestAnimationFrame(() => onSharedDragStart?.());
  };

  return (
    <div
      className={`relative flex items-center flex-shrink-0 ${canDragLink && !coarsePointer ? 'cursor-grab active:cursor-grabbing' : ''} ${className}`}
      draggable={canDragLink && !coarsePointer}
      onDragStart={canDragLink && !coarsePointer ? handleDragStart : undefined}
      onDragEnd={canDragLink && !coarsePointer ? () => onSharedDragEnd?.() : undefined}
      {...(coarsePointer && canDragLink ? touchHandlers : {})}
    >
      {canDragLink && (
        <div className="absolute -left-1 top-1/2 -translate-y-1/2 z-10 hidden group-hover/link:flex pointer-events-none group-hover/link:pointer-events-auto">
          <SharedDragGrip
            active
            title={coarsePointer ? 'Long-press to drag into a group' : 'Drag into a group'}
            size="md"
          />
        </div>
      )}
      {children}
    </div>
  );
};

export default DraggableLinkThumb;
